import { literal, preprocess } from 'zod';

import { CountProductsBySchema, ProductPurchaseSchema } from '@occc/validation';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

// `countProductsBy` is not offered by the Sweepstakes form (the "Count Products By"
// select is hidden), so it stays optional and falls back to Quantity on submit.
export const ProductPurchaseEarningMechanismSchema = ProductPurchaseSchema.extend({
  countProductsBy: CountProductsBySchema.optional(),
});

export const ProductPurchaseFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.ProductPurchase),
  productPurchase: preprocess((value) => value ?? {}, ProductPurchaseEarningMechanismSchema),
});
